// Les routes du labo compta, montées en développement seulement et HORS de
// RootRouterLayout (aucune auth) : la page des briques et la connexion du
// labo. Depuis le lot D6, tous les écrans de la coquille sont branchés sur de
// vraies données et vivent dans cabinetRoutes ; la coquille du labo, qui
// n'avait plus rien à montrer, est retirée.

import { EcranInterrompu } from "@dust-tt/front/components/compta/coquille/EcranInterrompu";
import { ROUTES_ENTREE } from "@dust-tt/front/components/compta/coquille/routes-compta";
import { useAppReadyContext } from "@spa/app/contexts/AppReadyContext";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { ReactNode } from "react";
import { useEffect } from "react";
import type { RouteObject } from "react-router-dom";

// Chaque écran arrive à la demande, comme dans tous les autres groupes
// de routes (adminRoutes, spacesRoutes…).
const ComptaBriquesPage = withSuspense(
  () => import("@dust-tt/front/components/pages/compta/ComptaBriquesPage"),
  "ComptaBriquesPage"
);
const ConnexionPage = withSuspense(
  () => import("@dust-tt/front/components/pages/compta/ConnexionPage"),
  "ConnexionPage"
);

interface RouteLaboProps {
  children: ReactNode;
}

// Ces routes sont autonomes : elles doivent lever elles-mêmes l'écran de
// chargement statique (index.html) que les layouts lèvent d'habitude.
function RouteLabo({ children }: RouteLaboProps) {
  const signalerAppReady = useAppReadyContext();
  useEffect(() => {
    signalerAppReady();
  }, [signalerAppReady]);
  return <>{children}</>;
}

// Le filet qui remplace un écran monté hors coquille. Il passe par RouteLabo
// comme l'écran qu'il remplace : sans cela, l'écran de chargement statique
// d'index.html n'est jamais levé et recouvre le message d'erreur, ce qui
// donne un chargement sans fin au lieu d'une explication.
const filetPleinEcran = (
  <RouteLabo>
    <EcranInterrompu pleinEcran />
  </RouteLabo>
);

// Un écran hors coquille : il tient la fenêtre, donc son filet aussi.
function route(chemin: string, ecran: ReactNode): RouteObject {
  return {
    path: chemin,
    element: <RouteLabo>{ecran}</RouteLabo>,
    errorElement: filetPleinEcran,
  };
}

// Le labo n'est monté qu'en développement : le 12/10, la prod servait à
// n'importe qui, sans connexion, des écrans remplis de sociétés fictives.
const LABO_MONTE = import.meta.env?.MODE === "development";

const maquettes: RouteObject[] = [
  // La page des briques : le catalogue visuel des composants.
  route(ROUTES_ENTREE.briques, <ComptaBriquesPage />),
];

// En prod, rien : la connexion y est servie par `cabinetUnauthenticatedRoutes`.
// En développement, la connexion du labo reste devant elle, comme avant.
export const laboRoutes: RouteObject[] = LABO_MONTE
  ? [route(ROUTES_ENTREE.connexion, <ConnexionPage />), ...maquettes]
  : [];
